import React from 'react'
import config from 'config'
import { get } from 'lodash'

import {
  PaymentPaypalInit,
  PaymentPaypalProceed,
  PaymentSuccess,
  PaymentFail
} from 'containers/pages'

const urlPrefix = `${config.publicPath}`

export default [
  {
    path: `${urlPrefix}/paypal-init/:authCode`,
    exact: true,
    component: props => (
      <PaymentPaypalInit
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/paypal/process`,
    exact: true,
    component: props => (
      <PaymentPaypalProceed
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/paypal/success`,
    exact: true,
    component: props => (
      <PaymentSuccess
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  },
  {
    path: `${urlPrefix}/paypal/cancel`,
    exact: true,
    component: props => (
      <PaymentFail
        {...props}
        params={get(props, 'match.params', {})}
      />
    ),
    routes: []
  }
]


